import {
  PROPERTY_TYPE_OPTION_HOME,
  PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES,
  PROPERTY_TYPE_OPTION_APARTMENT,
} from 'common/propertyTypes';

const propertyOptionItems = [
  {
    label: 'Homes',
    value: PROPERTY_TYPE_OPTION_HOME,
  },
  {
    label: 'Townhomes/Duplexes',
    value: PROPERTY_TYPE_OPTION_TOWNHOMES_DUPLEXES,
  },
  {
    label: 'Apartments',
    value: PROPERTY_TYPE_OPTION_APARTMENT,
  },
];

export default propertyOptionItems;
